import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "approval", "confirmation", "remember"]

  connect() {
    this.element.dataset.locationApprovalReady = "true"
  }

  disconnect() {
    delete this.element.dataset.locationApprovalReady
  }

  locationChanged() {
    this.confirmationTarget.checked = false
    this.rememberTarget.checked = false
    this.approvalTarget.value = ""
  }

  decisionChanged() {
    const approved = this.confirmationTarget.checked || this.rememberTarget.checked
    this.approvalTarget.value = approved ? this.locationTarget.value : ""
  }
}
